const topicEnum = {
  realTimeEntitlement: "/token/last-update"
};

export { topicEnum };
//# sourceMappingURL=topicEnum.js.map
